var _circle, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#B9BCC6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.0002 34.0789V31.4057C35.0002 29.9877 34.4433 28.6277 33.452 27.6251C32.4607 26.6224 31.1163 26.0591 29.7144 26.0591H19.1428C17.7409 26.0591 16.3964 26.6224 15.4051 27.6251C14.4138 28.6277 13.8569 29.9877 13.8569 31.4057V34.0789",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4284 22.4136C27.2396 22.4136 29.5185 20.1287 29.5185 17.3101C29.5185 14.4915 27.2396 12.2065 24.4284 12.2065C21.6173 12.2065 19.3384 14.4915 19.3384 17.3101C19.3384 20.1287 21.6173 22.4136 24.4284 22.4136Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.fc3ce5da14672a20ac678e1bfa0f9fda.svg";
export { ForwardRef as ReactComponent };